import React from "react";   // ✅ Add this

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    // For now, ignore free text and show default message
    actions.handleOptionClick("start");
  };

  return React.Children.map(children, (child) =>
    React.cloneElement(child, { parse, actions })
  );
};

export default MessageParser;
